'use es6';

import Client from 'AdsUI/data/Client';
import PortalIdParser from 'PortalIdParser';
const baseUrl = `ads/v1/event-settings`;
export default {
  getEventList() {
    return Client.apiRequest(baseUrl);
  },

  createManyEvents(network, accountId, events) {
    const url = `${baseUrl}/${network.toLowerCase()}/account/${accountId}/events?portalId=${PortalIdParser.get()}`;
    return Client.apiRequest(url, {
      type: 'POST',
      data: events
    });
  },

  createOfflineEvent(network, accountId, eventOpts) {
    const url = `${baseUrl}/${network.toLowerCase()}/account/${accountId}`;
    return Client.apiRequest(url, {
      type: 'POST',
      data: eventOpts
    });
  },

  updateEvent(eventId, eventOpts) {
    const url = `${baseUrl}/${eventId}`;
    return Client.apiRequest(url, {
      type: 'PUT',
      data: eventOpts
    });
  },

  getAdWordsAutoTaggingStatus(accountId) {
    return Client.apiRequest(`${baseUrl}/account/${accountId}/auto-tagging-status`);
  },

  deleteEvent(eventId) {
    return Client.apiRequest(`${baseUrl}/${eventId}`, {
      type: 'DELETE'
    });
  },

  fetchAllEventCategories(adNetwork, eventTrigger) {
    return Client.apiRequest(`${baseUrl}/${adNetwork}/event-categories/${eventTrigger}`);
  },

  getExistingGoogleEvents(accountId) {
    return Client.apiRequest(`${baseUrl}/adwords/account/${accountId}/webpage-conversion-actions`);
  }

};